import { useEffect, useState } from "react";

/**
 * Debounce a value by a delay, e.g. when you have a fast-changing values that you
 * want to react to, but your reaction might be asynchronous or slow, so you only want to react
 * to the latest value that you are able to consume.
 *
 * Usage:
 *      const [someValue, setSomeValue] = useState()
 *      const debouncedValue = useDebounce(someValue, 500)
 *
 *      useEffect(() => {
 *          if (debouncedValue) {
 *              // do something with it
 *          }
 *      }, [debouncedValue])
 *
 * @param {*} value
 * @param {*} delay
 * @return {*}
 */
const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

export default useDebounce;
